import { translation } from "@/configurations/i18n"
import {
  IS_BEFORE_EVENT_TIME,
  IS_BEFORE_REGISTER_TIME,
  IS_REGISTER_PERIOD
} from "@/constants/env"
import { route } from "@/constants/routes"

type TMenuItem = {
  title: string
  url: string
}

export const NAV_MENU_BEFORE_REGISTER_TIME: TMenuItem[] = [
  { title: translation.header.introductionToNDC, url: route.ABOUT },
  { title: translation.header.offline, url: route.OFFLINE },
  { title: translation.header.faq, url: route.FAQ },
  { title: translation.header.location, url: route.LOCATION }
]

export const NAV_MENU_DURING_REGISTER_TIME: TMenuItem[] = [
  { title: translation.header.introductionToNDC, url: route.ABOUT },
  { title: translation.header.session, url: route.SESSION },
  { title: translation.header.offline, url: route.OFFLINE },
  { title: translation.header.faq, url: route.FAQ },
  { title: translation.header.location, url: route.LOCATION }
]

export const NAV_MENU_AFTER_REGISTER_TIME: TMenuItem[] = [
  { title: translation.header.introductionToNDC, url: route.ABOUT },
  { title: translation.header.session, url: route.SESSION },
  { title: translation.header.faq, url: route.FAQ },
  { title: translation.header.location, url: route.LOCATION }
]

export const NAV_MENU_DURING_EVENT_TIME: TMenuItem[] = [
  { title: translation.header.introductionToNDC, url: route.ABOUT },
  { title: translation.header.session, url: route.SESSION },
  { title: translation.header.onlineStreaming, url: route.ONLINE_STREAMING },
  { title: translation.header.faq, url: route.FAQ },
  { title: translation.header.location, url: route.LOCATION }
]

const getNavMenu = () => {
  if (IS_BEFORE_REGISTER_TIME) return NAV_MENU_BEFORE_REGISTER_TIME
  if (IS_REGISTER_PERIOD) return NAV_MENU_DURING_REGISTER_TIME

  if (IS_BEFORE_EVENT_TIME) return NAV_MENU_AFTER_REGISTER_TIME

  return NAV_MENU_DURING_EVENT_TIME
}

export const NAV_MENU: TMenuItem[] = getNavMenu()
